export default {
  setItems(state, { type, value }) {
    state[type].items = value;
  },
  setPagination(state, { type, value }) {
    state[type].pagination = value;
  },
  setPeriod(state, { type, value }) {
    state[type].period = value;
  },
  setSort(state, { type, value }) {
    state[type].sort = value;
  },
  setPopstate(state, { type, value }) {
    state[type].popstate = value;
  },
  setInkAndTonersOnly(state, { type, value }) {
    state[type].inkAndTonersOnly = value;
  },
  setActiveFilter(state, { type, name, value }) {
    if (value === '') {
      delete state[type].activeFilters[name];
    } else {
      state[type].activeFilters = { ...state[type].activeFilters, [name]: value };
    }
  },
  setActiveFilters(state, { type, filters }) {
    state[type].activeFilters = Object.assign({}, filters);
  },
  setFilters(state, { type, value }) {
    state[type].filters = value;
  },
  setSortFilters(state, { type, value }) {
    state[type].sortFilters = value;
  },
  setCategoryName(state, { type, value }) {
    state[type].categoryName = value;
  },
  setCategoryId(state, { type, value }) {
    state[type].categoryId = value;
  },
  setCategoryLevel(state, { type, value }) {
    state[type].categoryLevel = value;
  },
  setCategories(state, { type, value }) {
    state[type].categories = value;
  },
  setFuzzySearch(state, { type, value }) {
    state[type].fuzzySearch = value;
  },
  setCategoryFilter(state, { type, value }) {
    state[type].categoryFilter = value;
  },
  setQuery(state, { type, value }) {
    state[type].query = value;
  },
  setDevice(state, { type, value }) {
    state[type].device = value;
  },
  setDeviceBrand(state, { type, value }) {
    state[type].deviceBrand = value;
  },
  setDeviceModel(state, { type, value }) {
    state[type].deviceModel = value;
  },
  setOemCode(state, { type, value }) {
    state[type].oemCode = value;
  },
  setResetFiltersFlag(state, { type, value }) {
    state[type].resetFiltersFlag = value;
  },
  setBreadcrumbs(state, { type, value }) {
    state[type].breadcrumbs = value;
  },
  setPromotionGroupId(state, { type, value }) {
    state[type].promotionGroupId = value;
  },
  setBrandId(state, { type, value }) {
    state[type].brandId = value;
  },
  setCatalogSubsetId(state, { type, value }) {
    state[type].catalogSubsetId = value;
  },
  setAtsQuery(state, { type, value }) {
    state[type].atsQuery = value;
  },
  setOnlyPalletPacks(state, { type, value }) {
    state[type].onlyPalletPacks = value;
  },
  setOnlyEco(state, { type, value }) {
    state[type].onlyEco = value;
  },
  resetState(state, { type }) {
    state[type] = Object.assign(state[type], {
      pagination: {
        limit: 36,
        offset: 0,
        countTotal: 0,
      },
      sort: '',
      activeFilters: {},
      filters: [],
      breadcrumbs: [],
      sortFilters: [],
      categoryId: '',
      categoryName: '',
      categoryLevel: '',
      categoryFilter: [],
      categories: [],
      query: '',
      device: '',
      period: 30,
      resetFiltersFlag: false,
      promotionGroupId: null,
      brandId: null,
      catalogSubsetId: null,
      atsQuery: null,
      onlyPalletPacks: false,
      onlyEco: false,
      fuzzySearch: null,
      popState: false,
      inkAndTonersOnly: '',
      deviceBrand: '',
      deviceModel: '',
      oemCode: '',
    });
  },
};
